import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Grid, Color, Type, Transition, Shadow } from '../app/StyleGuide';

const bounceIn = keyframes`
  0% {
    transform: translateY(100%);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(5px);
  }
  80% {
    transform: translateY(-2px);
  }
  100% {
    transform: translateY(0);
  }
`;

const DrawerOverlay = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  opacity: ${props => (props.isOpen ? 1 : 0)};
  visibility: ${props => (props.isOpen ? 'visible' : 'hidden')};
  transition: ${Transition.fast};
`;

const DrawerContainer = styled.div<{ isOpen: boolean }>`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: auto;
  max-height: 80vh;
  z-index: 1001;
  transform: translateY(${props => (props.isOpen ? '0' : '100%')});
  transition: transform ${Transition.fast};
  animation: ${props => (props.isOpen ? bounceIn : 'none')} 0.7s cubic-bezier(0.34, 1.56, 0.64, 1);
  border-top: 1px solid ${Color.Gray._20};
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;

  &::after {
    content: '';
    position: absolute;
    bottom: -100;
    left: 0;
    right: 0;
    height: 100px;
    background-color: ${Color.Orange};
    z-index: 1;
  }
`;

const DrawerContentContainer = styled.div`
  /* position: fixed;
  bottom: 0;
  left: 0;
  right: 0; */
  height: auto;
  max-height: 80vh;
  background-color: ${Color.white};
  box-shadow: 0 -10px 15px rgba(0, 0, 0, 0.06);

  padding: ${Grid._5};
  overflow-y: auto;
  transform-origin: bottom;
  will-change: transform;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;

  /* &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 20px;
    background-color: ${Color.white};
    z-index: 1;
  } */
`;

const DrawerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${Grid._5};
`;

const DrawerTitle = styled.h2`
  margin: 0;
  font-size: ${Type.Scale._5};
  color: ${Type.Color.dark};
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: ${Type.Scale._4};
  color: ${Type.Color.medium};
  cursor: pointer;
  padding: ${Grid._2};

  &:hover {
    color: ${Type.Color.dark};
  }
`;

interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  showBackdrop?: boolean;
  children: React.ReactNode;
  showCloseButton?: boolean;
}

export default function Drawer({
  isOpen,
  onClose,
  title,
  showBackdrop = true,
  children,
  showCloseButton = true,
}: DrawerProps) {
  return (
    <>
      {showBackdrop && <DrawerOverlay isOpen={isOpen} onClick={onClose} />}
      <DrawerContainer isOpen={isOpen}>
        <DrawerContentContainer>
          {title ||
            (showCloseButton && (
              <DrawerHeader>
                {title && <DrawerTitle>{title}</DrawerTitle>}
                {showCloseButton && (
                  <CloseButton onClick={onClose}>
                    <i className="fas fa-times" />
                  </CloseButton>
                )}
              </DrawerHeader>
            ))}

          {children}
        </DrawerContentContainer>
        <div
          style={{
            position: 'absolute',
            bottom: -100,
            left: 0,
            right: 0,
            height: '100px',
            width: '100%',
            backgroundColor: 'white',
            zIndex: 999,
          }}
        />
      </DrawerContainer>
    </>
  );
}
